import { useState } from "react";
import { useRequest } from "./useRequest";
import { WellProps } from "../interfaces/interfaces";

export const useToolsRunTrackedWells = () => {
  const { handleRequest } = useRequest();
  const [wellOptions, setWellOptions] = useState<WellProps[]>([]);

  const fetchDataWells = (clientId: number) => {
    setWellOptions([]);
    handleRequest({
      endpoint: `tools-run-wells/client/${clientId}`,
      options: { method: "GET" },
    })
      .then((response) => {
        if (response.data) setWellOptions(response.data);
      })
      .catch(() => setWellOptions([]));
  };

  return { wellOptions, fetchDataWells };
};
